import * as z$1 from "zod/v4";
//#region src/schemas/space-mesh/space-note.ts
const spaceNoteSchema = z$1.string().trim().min(1);
//#endregion
export { spaceNoteSchema };

//# sourceMappingURL=space-note.js.map